import { PROJECT } from 'constants/eppo';

import type { EppoClient } from './types';

import { createExperimentationClient } from 'experimentation-client-js';
import { metricWriter } from './writers/metricWriter';
import { createEventWriter } from './writers/eventWriter';

let eppoClient: EppoClient | null = null;
let eppoInitPromise: Promise<EppoClient> | null = null;

export const initEppo = async (): Promise<EppoClient> => {
    if (!eppoInitPromise) {
        eppoInitPromise = (async () => {
            const client = await createExperimentationClient({
                apiKey: import.meta.env.EPPO_SDK_KEY,
                stage: import.meta.env.ENV,
                projectName: PROJECT,
                projectNamespace: import.meta.env.PROJECT_NAME,
                eventWriter: createEventWriter(),
                metricWriter,
            });

            eppoClient = client;

            return client;
        })();
    }

    return eppoInitPromise;
};

export const getEppoClient = (): EppoClient | null => eppoClient;
